// extracted by mini-css-extract-plugin
export default {"container":"Chip_container__JIa0J","checkIcon":"Chip_checkIcon__Z7ry9","content":"Chip_content__V71II"};